import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    
    {
      path: '/detailsShow',//追溯扫码之后的手机页面
      name: 'detailsShow',
      component: () => import('../views/trace/detailsShow.vue')
    },
    //管理平台
    {path: '*',component: () => import('../components/error/NotFoundComponent')},
    {path: '/', redirect: '/login'},
    {path: '/login',name: '',component: () => import('../views/login/login')},
    {path: '/home',name: '',component: () => import('../components/home/home'),
    	children:[
    		{path: '',name: '',component: () => import('../components/slide/slide'),
          children:[
           

            {path: 'addAttr',name: '',component: () => import('../views/equipmentManage/addAttr')},
            {path: 'firm',name: '',component: () => import('../views/equipmentManage/firm')},
            {path: 'sensor',name: '',component: () => import('../views/equipmentManage/sensor')},
            {path: 'model',name: '',component: () => import('../views/equipmentManage/model')},

           
          ]
        },
    	]
    }
  ],
  mode:'history',
  // base: ''
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js